module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('v-layout', {
    attrs: {
      "row": "",
      "wrap": "",
      "mt-4": ""
    }
  }, [_c('v-flex', {
    staticClass: "hidden-xs-only",
    attrs: {
      "xs12": "",
      "sm4": "",
      "md1": "",
      "text-xs-right": ""
    }
  }, [_c('image-app', {
    staticClass: "animated fadeInLeft",
    attrs: {
      "imaSize": 100,
      "imaSrc": "design/gray-arrow",
      "imaAlt": ""
    }
  })], 1), _vm._v(" "), _c('v-flex', {
    staticClass: "animated fadeInUp",
    attrs: {
      "xs12": "",
      "sm6": "",
      "md6": ""
    }
  }, [_c('ui-title-one', {
    attrs: {
      "titleAccess": "Todas las Metas deben ser",
      "titleLevel": "h1"
    }
  }, [_c('template', {
    slot: "partOne"
  }, [_vm._v("Todas las metas"), _c('br')]), _vm._v(" "), _c('template', {
    slot: "partTwo"
  }), _vm._v(" "), _c('template', {
    slot: "partThree"
  }, [_vm._v(" deben ser:")])], 2)], 1), _vm._v(" "), _c('v-flex', {
    staticClass: "text-xs-center",
    attrs: {
      "xs12": ""
    }
  }, [_c('ui-simple-lsc', {
    attrs: {
      "vidTittle": 'Todas las metas deben ser',
      "videoEmbed": "ADMINISTRACIONDINERO05LasMetasDebenSer.mp4"
    }
  })], 1), _vm._v(" "), _c('v-flex', {
    staticClass: "animated fadeIn",
    attrs: {
      "xs12": "",
      "sm8": ""
    }
  }, [_c('p', [_c('strong', [_vm._v("Haga clic sobre cada característica:")])])])], 1), _vm._v(" "), _c('ui-botsacronimos', {
    staticClass: "text-xs-center",
    attrs: {
      "bots": _vm.bots,
      "nombreLista": "Tipos de crédito"
    }
  }, _vm._l((_vm.bots), function(item, index) {
    return _c('div', {
      key: 'content' + index,
      staticClass: "animated fadeInRight",
      attrs: {
        "slot": 'cont-' + index
      },
      slot: 'cont-' + index
    }, [_c('ui-title-one', {
      attrs: {
        "titleAccess": item.cont[0] + item.cont[1] + item.cont[2],
        "titleLevel": "p"
      }
    }, [_c('template', {
      slot: "partOne"
    }, [_vm._v(_vm._s(item.cont[0])), _c('br')]), _vm._v(" "), _c('template', {
      slot: "partTwo"
    }, [_vm._v(_vm._s(item.cont[1]))]), _vm._v(" "), _c('template', {
      slot: "partThree"
    }, [_vm._v(_vm._s(item.cont[2]))])], 2)], 1)
  })), _vm._v(" "), _c('v-flex', [_c('p', {
    staticClass: "mt-4"
  }, [_vm._v("Si quiere saber más acerca de la forma de establecer las "), _c('strong', [_vm._v("METAS")]), _vm._v(" en el curso El Ahorro encontrará la "), _c('strong', [_vm._v("Guía para Alcanzar las Metas")])])])], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-53f70e20","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/screens/00-davivienda/davivienda-05.vue
// module id = 975
// module chunks = 1